import { UserEnrollmentListItemModel } from '@/domain/models/content/enrollment/user-enrollment-list-model'

export interface UserEnrollmentList {
  get(): Promise<UserEnrollmentList.Model>
}

export namespace UserEnrollmentList {
  export type Model = UserEnrollmentListItemModel[]
  export const Key = 'user-enrollment-list'
}
